import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles } from '@material-ui/core'
import { CalendarToday, Info, ShowChart } from '@material-ui/icons'
import NextButton from './NextButton'
import CancelButton from './CancelButton'
import Stepper from './Stepper'
import FunnelIcon from 'components/theme/FunnelIcon'
import { withRouter } from 'react-router-dom'
import { stepperGoTo } from 'actions/view'

class StepperContainer extends Component {
	componentWillUnmount() {
		this.props.stepperGoTo(0, 'campaign')
	}

	render() {
		const locationSlice =
			this.props.location &&
			this.props.location.pathname &&
			this.props.location.pathname.slice &&
			this.props.location.pathname.slice(-4)

		const newEntity = locationSlice === '/new' || locationSlice === 'new/'

		const stepStyle = (int) => ({
			color: this.props.stepper === int ? '#18b940' : '#014c94',
		})

		const steps = [
			{
				label: 'Campaign',
				Icon: <Info style={stepStyle(0)} />,
			},
			{
				label: 'Funnel',
				Icon: <FunnelIcon style={stepStyle(1)} />,
			},
			{
				label: 'Calendar',
				Icon: <CalendarToday style={stepStyle(2)} />,
			},
			{
				label: 'Analyze',
				Icon: <ShowChart style={stepStyle(3)} />,
			},
		]

		return (
			<Grid
				container
				justify="space-between"
				className={this.props.classes.buttonsStyle}
			>
				<Grid item>
					<CancelButton />
				</Grid>
				<Stepper newEntity={newEntity} steps={steps} />
				<Grid item>
					<NextButton newEntity={newEntity} stepsLength={steps.length} />
				</Grid>
			</Grid>
		)
	}
}

const styles = (theme) => ({
	buttonsStyle: {
		[theme.breakpoints.down('xs')]: {
			width: '100%',
			left: 0,
			top: 56,
		},
		width: 'calc(100% - 80px)',
		position: 'fixed',
		left: '80px',
		// bottom: '0px',
		top: 64,
		padding: '12px',
		background: 'white',
		boxShadow: '0px 5px 5px #00000040',
		zIndex: 2,
		overflowY: 'hidden',
	},
})

export default withRouter(
	connect(
		(state) => ({ stepper: state.view.stepper.campaign }),
		(dispatch) => bindActionCreators({ stepperGoTo }, dispatch),
	)(withStyles(styles)(StepperContainer)),
)
